import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'

const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()

export default {
  async getPerguntaDoFeedback() {
    const APIRequest = await api.get('/feedback')
    return factory.build(APIRequest)
  },

  async getAllPerguntaDoFeedback() {
    const APIRequest = await api.get('/feedback/perguntas')
    return factory.build(APIRequest)
  },

  async usuarioRespondeFeedback(payload: {
    perguntaId: string;
    ignorou: boolean;
    texto: string;
    nota: number;
  }) {
    const APIRequest = await api.post('/feedback/respostas', payload)
    return factory.build(APIRequest)
  },

  async upsertPerguntaDoFeedback(payload: {
    id: string | null;
    texto: string;
    dataInicio: string;
    dataFim: string;
    tiposDeUsuario: string[];
    limiteDeTentativasDeColetaDeFeedback: number;
    permiteMultiplasRespostas: boolean;
  }) {
    const APIRequest = await api.post('/feedback/perguntas', payload)
    return factory.build(APIRequest)
  },

  async getRespostasDoFeedback(perguntaId?: string) {
    const APIRequest = await api.get(`/utilidades/feedback${perguntaId ? `?perguntaid=${perguntaId}` : ''}`)
    return factory.build(APIRequest)
  },
}
